// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.admanagement.selfserveonboarding.RentalManagerUserSelfServiceOnboardingWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-beta-client';

interface SubmitManualListingParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing_Args {
  getParams: SubmitManualListingParams;
}

export type RentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing_Args
>;

/**
 * Submit manual self serve onboarding listing for review
 */
export const useRentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing_Args) =>
      RentalManagerUserSelfServiceOnboardingWebApiHandler_submitManualListing(args.getParams, httpClient),
  });
};
